import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="signing-up" />;

export const Route = createFileRoute("/en/thank-you/signing-up")({
  head: () => buildRouteHead("/en/thank-you/signing-up"),
  component: ThankYouRoute,
});

